/**
 * Lazy-init language event bus — the replacement for ShareGardens'
 * `window.emitter` (whose listener registration was module-load-order
 * dependent: a component that loaded before the emitter was created silently
 * never received events — plan §1c yousophy guardrail).
 *
 * Every caller goes through `getLanguageEvents()`, which creates the singleton
 * on FIRST access from anywhere — no ordering dependence. SSR-safe: on the
 * server it returns an inert no-op emitter.
 *
 * Events used by this extension:
 *   'languageChanged'  payload: the new language code (emitted before reload)
 */

const GLOBAL_KEY = '__empavisionLanguageEvents__';

const createEmitter = () => {
  const listeners = {};
  return {
    on(event, callback) {
      (listeners[event] = listeners[event] || []).push(callback);
    },
    off(event, callback) {
      if (!listeners[event]) return;
      listeners[event] = listeners[event].filter(cb => cb !== callback);
    },
    emit(event, payload) {
      (listeners[event] || []).forEach(callback => {
        try {
          callback(payload);
        } catch (_) {
          // one bad listener must not break the others
        }
      });
    },
  };
};

const noopEmitter = { on: () => {}, off: () => {}, emit: () => {} };

export const getLanguageEvents = () => {
  if (typeof window === 'undefined') return noopEmitter;
  if (!window[GLOBAL_KEY]) {
    window[GLOBAL_KEY] = createEmitter();
  }
  return window[GLOBAL_KEY];
};
